import React, { useEffect, useState } from 'react';
import {
  Row, Col, Table, Card, Spinner, Container,
} from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom';
import axios from 'axios';
import { ButtonKembali, Content } from './styles';
import Navbar from '../../../components/Navbar';
import Header from '../../../components/Header';
import { Loader } from '../../Superadmin/TambahAdmin/styles';
import config from '../../../config';

const DetailPengajuanPartisipasi = () => {
  const [loading, setLoading] = useState(true);
  const [dataDetail, setDataDetail] = useState({ mahasiswa: { user: {} }, kum: { } });
  const { idKum } = useParams();
  const history = useHistory();

  const fetchDetail = () => {
    setLoading(true);
    axios.get(`${config.API_BASE_URL}api/partisipasi_kuliah_umum/detail/${idKum}/`, {
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }).then(
      ({ data }) => {
        const tempData = data;
        tempData.kum.biaya = new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(data.kum.biaya);
        setDataDetail(data);
        setLoading(false);
      },
    );
    setLoading(false);
  };

  const handleBack = () => {
    history.goBack();
  };

  useEffect(() => {
    fetchDetail();
  }, []);

  if (loading) {
    return (
      <Loader>
        <Spinner animation="border" />
      </Loader>
    );
  }

  return (
    <>
      <Navbar />
      <Header />
      <Container className="mt-4">
        <Content>
          <Card>
            <Card.Header>
              <ButtonKembali onClick={handleBack}>
                Kembali
              </ButtonKembali>
              <div className={Content}>
                <h3 className="text-center">
                  Detail Partisipasi Kegiatan Kuliah Umum
                </h3>
              </div>
            </Card.Header>
            <Card.Body>
              <div>
                <Row>
                  <Col md={{ span: 6 }}>
                    <div>
                      <Table responsive="sm">
                        <tbody>
                          <tr>
                            <td>Nama Pengaju</td>
                            <td>{dataDetail.mahasiswa.user.name}</td>
                          </tr>
                          <tr>
                            <td>NPM</td>
                            <td>{dataDetail.mahasiswa.user.npmnip}</td>
                          </tr>
                          <tr>
                            <td>Prodi</td>
                            <td>{dataDetail.mahasiswa.prodi}</td>
                          </tr>
                          <tr>
                            <td>Jenis Kegiatan</td>
                            <td>{dataDetail.kum.jenis_kegiatan}</td>
                          </tr>
                          <tr>
                            <td>Dokumen</td>
                            <td>
                              <a
                                style={{
                                  display: 'inline-block', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', width: '20em',
                                }}
                                href={dataDetail.bukti_registrasi}
                              >
                                {dataDetail.bukti_registrasi}
                              </a>
                              {dataDetail?.sertifikat && (
                              <a
                                style={{
                                  display: 'inline-block', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', width: '20em',
                                }}
                                href={dataDetail.sertifikat}
                              >
                                {dataDetail.sertifikat}
                              </a>
                              )}

                            </td>
                          </tr>

                        </tbody>
                      </Table>
                    </div>
                  </Col>
                  <Col md={{ span: 6 }}>
                    <div>
                      <Table responsive="sm">
                        <tbody>
                          <tr>
                            <td>Nama Kegiatan</td>
                            <td>{dataDetail.kum.nama_kegiatan}</td>
                          </tr>
                          <tr>
                            <td>Narasumber</td>
                            <td>{dataDetail.kum.jenis_kegiatan}</td>
                          </tr>
                          <tr>
                            <td>Hari/Tanggal</td>
                            <td>{dataDetail.kum.tanggal}</td>
                          </tr>
                          <tr>
                            <td>Pukul</td>
                            <td>{dataDetail.kum.tanggal}</td>
                          </tr>
                          <tr>
                            <td>Penyelenggara</td>
                            <td>{dataDetail.kum.penyelenggara}</td>
                          </tr>
                          <tr>
                            <td>Biaya</td>
                            <td>{dataDetail.kum.biaya}</td>
                          </tr>
                          <tr>
                            <td>Lokasi</td>
                            <td>{dataDetail.kum.lokasi}</td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </Col>
                </Row>

              </div>
            </Card.Body>
          </Card>
        </Content>
      </Container>
    </>
  );
};

export default DetailPengajuanPartisipasi;
